import styled from 'styled-components';
import tw from 'twin.macro';

const Input = styled.input`
  ${tw`box-border w-full bg-white/70 inline-flex h-10 appearance-none items-center justify-center rounded-lg px-3 leading-none text-slate-800 border border-slate-300 hover:border-slate-600 outline-none transition shadow-[0_0_0_0_rgb(var(--color-primary)_/_0)] focus:shadow-[0_0_0_4px_rgb(var(--color-primary)_/_0.2)] focus:bg-white focus:border-primary selection:bg-slate-200`};
`;

export default Input;
